/* eslint-disable react/jsx-no-target-blank */
import { useEffect } from 'react';
import { useIntl } from 'react-intl'
import { AsideMenuItem } from './AsideMenuItem'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'

export function AsideMenuMaster({ setItensAdicionais }: { setItensAdicionais: React.Dispatch<React.SetStateAction<JSX.Element[]>> }) {
  const intl = useIntl();
  const subMenuParametrizacao = [
    <AsideMenuItem
      key='parametrizacoes'
      to='/parametrizacoes'
      title={intl.formatMessage({ id: 'MENU.PARAMETERIZATION' })}
    />,
    <AsideMenuItem
      key='cnae'
      to='/cnae'
      title={intl.formatMessage({ id: 'MENU.CNAE' })}
    />,
    <AsideMenuItem
      key='retencaoFonte'
      to='/retencaoFonte'
      title={intl.formatMessage({ id: 'MENU.RETENCAO_NA_FONTE' })}
    />,
    <AsideMenuItem
      key='obrigacaoAcessorias'
      to='/obrigacaoAcessorias'
      title={intl.formatMessage({ id: 'MENU.OBRIGACAO_ACESSORIAS' })}
    />
  ];
  const itensRodape = [
    <AsideMenuItem
      to='/usuarios'
      title={intl.formatMessage({ id: 'MENU.USERS' })}
      fontIcon='bi bi-people'
    />,
    <AsideMenuItem
      to='/permissoes'
      title={intl.formatMessage({ id: 'MENU.PERMISSIONS' })}
      fontIcon='bi bi-lock'
    />
  ];

  useEffect(() => {
    setItensAdicionais(itensRodape);
    
    //eslint-disable-next-line
  }, [])

  return (
    <>
      <AsideMenuItem
        to='/clientes'
        title={intl.formatMessage({ id: 'MENU.CLIENTS' })}
        fontIcon='bi bi-grid'
      />

      <AsideMenuItem
        to='/calendario'
        title={intl.formatMessage({ id: 'MENU.CALENDAR' })}
        fontIcon='far fa-calendar'
      />

      <AsideMenuItem
        to='/mensagens'
        title={intl.formatMessage({ id: 'MENU.MENSAGENS' })}
        fontIcon='bi bi-chat-left'
      />

      <AsideMenuItemWithSub
        to=''
        title={intl.formatMessage({ id: 'MENU.PARAMETERIZATION' })}
        fontIcon='fas fa-cog'
        children={subMenuParametrizacao}
      />

      <AsideMenuItem
        to='/eventos'
        title={intl.formatMessage({ id: 'MENU.EVENTS' })}
        fontIcon='fas fa-layer-group'
      />

      <AsideMenuItem
        to='/documentosRegras'
        title={intl.formatMessage({ id: 'MENU.DOCUMENTOS_REGRAS' })}
        fontIcon='bi bi-check2-circle'
      />

      <AsideMenuItem
        to='/fisco'
        title={intl.formatMessage({ id: 'MENU.FISCO' })}
        fontIcon='fas fa-file-invoice-dollar'
      />
    </>
  )
}
